
import React, { useState, useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import ChildComponent from "./depodetail";
import { makeRequest } from "../../axios";
import './kmdepo.css';

const Pay = () => {
  // State for storing deposit entries in an array
  const [deposits, setDeposits] = useState([]);
  const [depo, setDepo] = useState([]);
  const [depositData, setDepositData] = useState({
    amount: '',
    currency: ''
  });
  const [selectedComponent, setSelectedComponent] = useState('list');

  // Animation for the form container
  const formAnimation = useSpring({
    opacity: 1,
    transform: 'translateY(0px)',
    from: { opacity: 0, transform: 'translateY(-20px)' }
  });


  useEffect(() => {
    makeRequest.get("user-info/alltransactions").then((res) => {
      setDepo(res.data);
    });
  }, []);
  
  // Handle input change and update depositData
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDepositData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  console.log(deposits)
  console.log(depositData)

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add new deposit to the array
    setDeposits((prevDeposits) => [...prevDeposits, { ...depositData }]) 
    console.log(deposits)
    setSelectedComponent('form')
    // setDepositData({ amount: '', currency: 'btc' }); // Reset form inputs
    
    // alert(`Deposited ${depositData.amount} ${depositData.currency.toUpperCase()}`);
  };

  return (
    <>
    {
       selectedComponent === "list" && (
    <animated.div style={formAnimation} className="deposit-form-container">
      <h2>Crypto Deposit</h2>

      <form onSubmit={handleSubmit}>
        {/* Amount input */}
        <label htmlFor="amount">Amount to Deposit</label>
        <input
          type="number"
          id="amount"
          name="amount"
          value={depositData.amount}
          onChange={handleChange}
          placeholder="Enter amount"
          min="0"
          step="0.0001"
        />

        {/* Crypto currency selection */}
        <label htmlFor="currency">Select Cryptocurrency</label>
        <select
          id="currency"
          name="currency"
          value={depositData.currency}
          onChange={handleChange}
        >
          <option value=""></option>
          <option value="BTC">BITCOIN (BTC)</option>
          <option value="ETH">ETHEREUM (ETH)</option>
          <option value="USDT erc20">USDT erc20 (USDT)</option>
          <option value="USDT trc20">USDT trc20 (USDT)</option>
          <option value="SOLANA">SOLANA (SOL)</option>
          <option value="LITECOIN">LITECOIN (LTC)</option>
        </select>

        {/* Submit button */}
        <button type="submit" className="deposit-button">
          Deposit
        </button>
      </form>

      {/* List of deposits */}
      <div className="deposit-history">
        <h3>Deposit History</h3>
        <ul>
          {depo.map((deposit, index) => (
            < div style={{display:"flex", justifyContent:"space-between"}}>
            <li key={deposit.transaction_id} >
              {deposit.type === "DEPOSIT" ? deposit.amount : null} 
            </li>
            <li>{deposit.type === "DEPOSIT" ? deposit.method_details : null}</li>
            <li>{deposit.type === "DEPOSIT" ? deposit.trans_status : null}</li>
            </div>
          ))}
        </ul>
      </div>
    </animated.div>
       )}

{
      selectedComponent === "form" && (
        <>
        <ChildComponent message={deposits}/>
        </>
      )}

    </>
  );
};

export default Pay;




// import { useState, useContext, useEffect } from "react";
// import btc from "../../assets/BTC.svg"
// import "./kmdepo.scss"
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import { makeRequest } from "../../axios";
// import ChildComponent from "./depodetail";



// const Pay = () => {
// const [selectedComponent, setSelectedComponent] = useState('list');
// const [method, setMethod] = useState("")
// const [depo, setDepo] = useState(false)
// const [depo1, setDepo1] = useState(false)
// const [depo2, setDepo2] = useState(false)
// const [depo3, setDepo3] = useState(false)
// const [inputs, setInputs] = useState({amount: '', currency: '' });
// const [items, setItems] = useState([]);

// console.log(items);

// const handledepo = (e) => {
//   setDepo(true)
// }
// const handledepo1 = (e) => {
//   setDepo1(true)
// }
// const handledepo2 = (e) => {
//   setDepo2(true)
// }
// const handledepo3 = (e) => {
//   setDepo3(true)
// }

// const handleChange = (e) => {
//   setInputs(e.target.value)
//   };

//   const handleSubmit = (e) => {
    
//     if (inputs.trim() !== '') {
//      setItems([...items, inputs]);
      
//     }
//   };


//   const [err, setErr] = useState(null);
//   const handleClick = async (e) => {
//     e.preventDefault();

//     try {
//       await makeRequest.post("trans/deposit", inputs);

//     } catch (err) {
//       setErr(err.response.data);
//     }
//   };


//   return (
//     <>
//         {
//       selectedComponent === "list" && (
//         <div className='features' >
//         {/* {open && <FormModal open={open} onClose={handleClose} />} */}
//         <div className='features-1 col' >
//             <div className="col f-fcol" >
//                 <img className="f-images" src={btc} alt='' />
//                 <div className='col f-col'  >
//                     <span className="f-header" >BTC</span>
//                     <span className='f-content' >Pay with Bitcoin</span>
//                 </div>
                
//                 { !depo ? <button 
//                   onClick={() => {handledepo()}}>Deposit
//                 </button> :
//                 <div style={{textAlign:"center"}}>
//                 <input type="text" name="amount"  onChange={handleChange}/> <br></br>
//                 <select onChange={handleChange} style={{width:"100%"}}>
//                   <option></option>
//                   <option name="currency" value="BTC">BTC</option>
//                 </select>
//                  <button onClick={()=> { handleSubmit(); setSelectedComponent('form')}}>deposit</button> 
//                  </div>  }
                   
//             </div>
//             <div className="col f-fcol" >
//                 <img className="f-images" src={btc} alt='' />
//                 <div className='col f-col' >
//                     <span className="f-header" >ETH</span>
//                     <span className='f-content' >Pay with Ethereum</span>
//                 </div>

//                 { !depo1 ? <button 
//                   onClick={() => {handledepo1()}}>Deposit
//                 </button> :
//                 <div style={{textAlign:"center"}}>
//                 <input type="text" name="amount"  onChange={handleChange}/> <br></br>
//                 <input type="text" name="currency" value="Ethereum" onChange={handleChange} style={{display:""}}/> <br></br>
//                  <button onClick={()=> { handleSubmit(); setSelectedComponent('form')}}>deposit</button> 
//                  </div>  }

//             </div>
            
//         </div>
    
//         <div className='features-1 col'  >
//         <div className="col f-fcol" >
//                 <img className="f-images" src={btc} alt='' />
//                 <div className='col f-col' >
//                     <span className="f-header" >USDT</span>
//                     <span className='f-content' >Pay with USDT</span>
//                 </div>
//                 <button 
//                   onClick={() => {
//                     setSelectedComponent('form');
//                     setMethod("USDT");
//                   }}
//                 >
//                   Deposit
//                 </button>

//             </div>
//             <div className="col f-fcol" >
//                 <img className="f-images" src={btc} alt='' />
//                 <div className='col f-col' >
//                     <span className="f-header" > BTC CASH</span>
//                     <span className='f-content' >Pay with BTC CASH</span>
//                 </div>
//                 <button 
//                   onClick={() => {
//                     setSelectedComponent('form');
//                     setMethod("BTC CASH");
//                   }}
//                 >
//                   Deposit
//                 </button>

//             </div>
//         </div>     
//           </div>
    
//       )
//     }


// {
//       selectedComponent === "form" && (
//         <>
//         <ChildComponent message={items}/>
//         </>
//     // <div
//     //   className="modal show"
//     //   style={{ display: 'block', position: 'initial' }}
//     // >
//     //   <Modal.Dialog>
//     //     <Modal.Header
//     //      onClick={() => {
//     //        setSelectedComponent('list');
//     //      }}
        
//     //      closeButton >
//     //       <Modal.Title>Enter amount</Modal.Title>
//     //     </Modal.Header>

//     //     <Modal.Body>
//     //       <input name='amount' type="number"  placeholder='Enter amount' onChange={handleChange} />
//     //     </Modal.Body>

//     //     <Modal.Footer>
//     //       <Button variant="primary" onClick={handleClick} >Procced</Button>
//     //     </Modal.Footer>
//     //   </Modal.Dialog>
//     // </div>

//       )
//     }
//     </>


//   )
// }

// export default Pay;